import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
    partnerName?: string;
    linkText?: string;
}

export function getPrivacyPolicyUrl(partnerName: string | undefined) {
    if (partnerName === undefined) {
        return 'https://rio.cloud/fileadmin/Marketplace/RIO/Products/Fleet/Localized/de-DE/Fleet_privacy_policy.pdf';
    }
    return `https://rio.cloud/fileadmin/Marketplace/RIO/Partner/partner_${partnerName}_privacy_policy.pdf`;
}

export const PrivacyPolicyOpener = ({ partnerName, linkText }: Props) => {
    const url = getPrivacyPolicyUrl(partnerName);
    const [show, setShow] = useState(false);
    const intl = useIntl();
    const dialogTitleId = 'marketplace.partners.table.header.privacyPolicy';
    const iframeTitle = intl.formatMessage({ id: dialogTitleId });

    return (
        <>
            <Dialog
                show={show}
                title={<FormattedMessage id={dialogTitleId} />}
                body={
                    <iframe
                        className='position-absolute top-0 left-0 width-100pct height-100pct'
                        src={url}
                        title={iframeTitle}
                    />
                }
                onClose={() => setShow(false)}
                footer={null}
                showCloseButton={true}
                bsSize={Dialog.SIZE_FULL_SCREEN}
            />

            <span>
                {linkText ? (
                    <a href={url} onClick={event => setShow(true)}>
                        {linkText}
                    </a>
                ) : (
                    <Button
                        type='button'
                        className={'btn btn-default btn-link padding-0'}
                        onClick={() => setShow(true)}
                        autoTrackingKey='marketplace.showDocument'
                    >
                        <span className={'uikit-icon icon-document cursor-pointer'} />{' '}
                        <FormattedMessage id={'marketplace.showDocument'} />
                    </Button>
                )}
            </span>
        </>
    );
};
